import {Component, inject, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import { TranslateUnauthenticatedPipe } from '../../filters/translate-unauthenticated.pipe';
import {LoaderOverlayComponent} from "../loader-overlay/loader-overlay.component";
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import $ from "jquery";

@Component({
    standalone: true,
    selector: 'modal-safety-results-individual',
    templateUrl: './modal-safety-results-individual.component.html',
    imports: [
        CommonModule, TranslateUnauthenticatedPipe, LoaderOverlayComponent
    ]
})
export class ModalSafetyResultsIndividualComponent implements OnInit {
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
    private dialogRef = inject(MatDialogRef<ModalSafetyResultsIndividualComponent>);
    private data = inject(MAT_DIALOG_DATA);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
        var w: any = $(window).width();
        this.vm.isSmallSizeWindow = (w ? w <= 768 : false);
        this.vm.titleFontSize = this.vm.isSmallSizeWindow ? '16px' : '22px';
        this.vm.safetyGroupT = this.getSafetyGroupTitle(this.vm.score);
        this.vm.safetyGroupTitle = this.vm.safetyGroupT;


        this.vm.close = this.close;
        this.vm.formatTranslation = this.formatTranslation;

    }

    getSafetyGroupTitle(score) {
        if (score > 0 && score <= 10) {
            this.vm.veryLowPsychologicalSafety = true;
            return this.formatTranslation(this.angularFilterHelperService.translateUnauthenticated('Surveys.Very_Low_Psychological_Safety_Title'));
        } else if(score >= 11 && score <= 20) {
            this.vm.lowPsychologicalSafety = true;
            return this.formatTranslation(this.angularFilterHelperService.translateUnauthenticated('Surveys.Low_Psychological_Safety_Title'));
        } else if(score >= 21 && score <= 29) {
            this.vm.moderateToHighPsychologicalSafety = true;
            return this.formatTranslation(this.angularFilterHelperService.translateUnauthenticated('Surveys.Moderate_To_High_Psychological_Safety_Title'));
        } else if(score >= 30 && score <= 35) {
            this.vm.veryHighPsychologicalSafety = true;
            return this.formatTranslation(this.angularFilterHelperService.translateUnauthenticated('Surveys.Very_High_Psychological_Safety_Title'));
        } else {
            return '';
        }
    }

    close() {
        this.dialogRef.close(undefined);
    }

    formatTranslation(text: string): string {
        if (!text) return '';
        return text.replace(/<b>/g, '<strong>').replace(/<\/b>/g, '</strong>');
    }
}